import * as React from 'react';
import {DatadogErrorBoundary} from '@treatwell/ui/datadog';

import {GenericError} from '.';

interface Props {
  children: React.ReactElement | React.ReactElement[];
  errorComponent?: React.ReactElement;
  trackError?: (errorMessage: Error) => Promise<void>;
}

export const ErrorBoundary = (props: Props) => (
  <DatadogErrorBoundary
    genericErrorComponent={props.errorComponent || <GenericError />}
    handleError={(error) => {
      if (error instanceof Error) {
        props.trackError?.(error);
      }
    }}
  >
    {props.children}
  </DatadogErrorBoundary>
);
